import { render, staticRenderFns } from "./contractMegabiz.vue?vue&type=template&id=0fe6a800"
import script from "./contractMegabiz.vue?vue&type=script&lang=js"
export * from "./contractMegabiz.vue?vue&type=script&lang=js"
import style0 from "./contractMegabiz.vue?vue&type=style&index=0&id=0fe6a800&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports